var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgSubtype(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5C7 2.23858 9.23858 0 12 0H60C62.7614 0 65 2.23858 65 5V23C65 25.7614 62.7614 28 60 28H12C9.23858 28 7 25.7614 7 23V5Z",
    fill: "#EF7C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 55C0 52.2386 2.23858 50 5 50H29C31.7614 50 34 52.2386 34 55V67C34 69.7614 31.7614 72 29 72H5C2.23858 72 0 69.7614 0 67V55Z",
    fill: "#E62645"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55C38 52.2386 40.2386 50 43 50H67C69.7614 50 72 52.2386 72 55V67C72 69.7614 69.7614 72 67 72H43C40.2386 72 38 69.7614 38 67V55Z",
    fill: "#E62645"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 22.5C38.433 22.5 40 20.933 40 19C40 17.067 38.433 15.5 36.5 15.5C34.567 15.5 33 17.067 33 19C33 20.933 34.567 22.5 36.5 22.5Z",
    fill: "#EF7C00",
    stroke: "#FFEADB",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 27C37.5 26.4477 37.0523 26 36.5 26C35.9477 26 35.5 26.4477 35.5 27L37.5 27ZM25.5 39L25.5 38L25.5 39ZM35.5 27L35.5 31L37.5 31L37.5 27L35.5 27ZM28.5 38L25.5 38L25.5 40L28.5 40L28.5 38ZM16.5 47L16.5 60L18.5 60L18.5 47L16.5 47ZM25.5 38C20.5294 38 16.5 42.0294 16.5 47L18.5 47C18.5 43.134 21.634 40 25.5 40L25.5 38ZM35.5 31C35.5 34.866 32.366 38 28.5 38L28.5 40C33.4706 40 37.5 35.9706 37.5 31L35.5 31Z",
    fill: "#E62645"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 50L16.5 58L18.5 58L18.5 50L16.5 50Z",
    fill: "#FFEFF0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 23C35.5 22.4477 35.9477 22 36.5 22C37.0523 22 37.5 22.4477 37.5 23L35.5 23ZM37.5 23L37.5 31L35.5 31L35.5 23L37.5 23ZM44.5 38L47.5 38L47.5 40L44.5 40L44.5 38ZM56.5 47L56.5 60L54.5 60L54.5 47L56.5 47ZM47.5 38C52.4706 38 56.5 42.0294 56.5 47L54.5 47C54.5 43.134 51.366 40 47.5 40L47.5 38ZM37.5 31C37.5 34.866 40.634 38 44.5 38L44.5 40C39.5294 40 35.5 35.9706 35.5 31L37.5 31Z",
    fill: "#E62645"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 50L56.5 58L54.5 58L54.5 50L56.5 50Z",
    fill: "#FFEFF0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 22.5C35.5 21.9477 35.9477 21.5 36.5 21.5C37.0523 21.5 37.5 21.9477 37.5 22.5L35.5 22.5ZM37.5 22.5L37.5 28L35.5 28L35.5 22.5L37.5 22.5Z",
    fill: "#FFEADB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14 56L17.5355 59.5355",
    stroke: "#FFEFF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52 56L55.5355 59.5355",
    stroke: "#FFEFF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0355 55.9643L17.5 59.4999",
    stroke: "#FFEFF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0355 55.9643L55.5 59.4999",
    stroke: "#FFEFF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSubtype);
export default __webpack_public_path__ + "static/media/imgSubtype.551420c7d2f8e01c325f84f1bb01a160.svg";
export { ForwardRef as ReactComponent };